module.exports = __webpack_public_path__ + "img/ring_r_s_1_1@3x.244613f3.png";